import { Ticker } from "pixi.js";

export class GuestAuthInfo {
    private idValue: string;
    public get id(): string {
        return this.idValue;
    }

    private constructor() {
        const guestId = (window as any)._CVT_GUEST_ID;
        if (guestId == undefined || guestId === "") {
            throw new Error("Failed to create guestId.");
        }
        this.idValue = guestId;
    }

    public static async fromProvidedInfo(ticker: Ticker): Promise<GuestAuthInfo> {
        return new Promise((resolve, reject) => {
            function WaitForGuestId() {
                const guestId = (window as any)._CVT_GUEST_ID;
                if (guestId == undefined || guestId === "") {
                    return;
                }
                ticker.remove(WaitForGuestId);
                resolve(new GuestAuthInfo());
            };
            ticker.add(WaitForGuestId);
        });
    }
}
